import * as requestFromServer from "./SubscriptionExpiryCrud";
import { SubscriptionExpirySlice, setLoading } from "./SubscriptionExpirySlice";
import { UISlice } from "../UISlice";

const { actions: SubscriptionExpiryActions } = SubscriptionExpirySlice;
const { actions: UIActions } = UISlice;

export const fetchSubscriptionExpiry = (duration) => (dispatch) => {
  dispatch(UIActions.openLoader());
  dispatch(setLoading(true));

  let fetchFunction = requestFromServer.getMyNotifications;

  return fetchFunction(duration)
    .then((response) => {
      if (response.data.status) {
        dispatch(
          SubscriptionExpiryActions.setSubscriptionExpiry(response.data.data)
        );
      }
    })
    .catch((error) => {
      dispatch(SubscriptionExpiryActions.catchError(error));
    })
    .finally(() => {
      dispatch(UIActions.closeLoader());
      dispatch(setLoading(false));
    });
};
